import { serviceHost } from '../../common/const';
import ServiceRequest from '../../utils/service-request';


export const saveCustomerAnalysisData = async (data) => {
    try {
        let response = await ServiceRequest('post', 'json', serviceHost + '/analysis/saveCustomerAnalysis', data);
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}

export const getCustomerAnalysisData = async (data) => {
    try {
        let response = await ServiceRequest('post', 'json', serviceHost + '/analysis/getCustomerAnalysis', data);
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}